import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// You would typically import the image from your assets folder.
// For demonstration, let's assume the image is available via a URL or a local import.
// Replace 'path/to/founder-image.png' with your actual image path.
const founderImage = "/images/Founder.webp";
// If you are using an image directly from the user's uploaded file:
// const founderImage = 'image_b981c2.png';

const FounderTestimonial = () => {
  // --- Refs for GSAP Animation ---
  const droppedImageRef = useRef(null);
  const sectionRef = useRef(null);

  useEffect(() => {
    // GSAP context to limit animations to this component
    const context = gsap.context(() => {
      // --- 1. Scrubbed Text Reveal Animation (Merise.ae style) ---
      const textElements = gsap.utils.toArray(
        sectionRef.current.querySelectorAll(".animated-text-content")
      );

      textElements.forEach((element, index) => {
        // Set Initial State: Hidden (opacity: 0), slightly down (y: 25), and clipped from the bottom
        gsap.set(element, {
          y: 25,
          opacity: 0,
          clipPath: "inset(100% 0 0% 0)",
        });

        const tl = gsap.timeline({
          scrollTrigger: {
            // trigger: element.closest("div"), // Using the element itself is often better for text lines
            trigger: element,
            start: "top 85%", // Animation shuru karo jab element screen mein aana shuru ho
            end: "center 60%", // Animation end karo jab element screen mein lagbhag center ho
            scrub: 1, // Scroll se smooth link (scrubbing)
            // markers: true,
          },
        });

        // Define the Target State: Visible (opacity: 1), original position (y: 0), and fully unclipped
        // Scroll down karne par (timeline forward), text 25px se 0px par aayega (Neeche se Upar).
        tl.to(element, {
          y: 0, // Final state: Original position
          opacity: 1,
          clipPath: "inset(0% 0 0% 0)", // Fully visible
          duration: 1,
          ease: "power2.out", // Thoda smooth movement
          delay: index * 0.1, // Stagger effect for line-by-line reveal
        });
      });

      // --- 2. Scrubbed Divider Line Animation (Grow from Left) ---
      // Note: I'm using the first text element as the trigger here since we don't have a specific subtitle container.
      const lineElement = sectionRef.current.querySelector(
        ".about-divider-line"
      );
      if (lineElement) {
        // Initial State: Hidden (scaleX: 0) and set origin to the left
        gsap.set(lineElement, { scaleX: 0, transformOrigin: "left" });

        gsap.to(lineElement, {
          scaleX: 1, // Target state is visible (full width)
          duration: 1,
          ease: "none",
          scrollTrigger: {
            trigger: lineElement, // Trigger on the line element itself
            start: "top 85%",
            end: "center 60%",
            scrub: 1,
          },
        });
      }

      // --- 3. Dropped Image Rotation Animation ---
      const rightContentContainer = sectionRef.current.querySelector(
        ".right-content-container"
      );

      if (droppedImageRef.current && rightContentContainer) {
        gsap.to(droppedImageRef.current, {
          rotation: 360, // 360 degree rotation
          duration: 3,
          ease: "none",
          scrollTrigger: {
            trigger: rightContentContainer,
            start: "top bottom", // जब कंटेनर नीचे से दिखाई दे
            end: "bottom top", // जब कंटेनर ऊपर से गायब हो जाए
            scrub: 1, // Scroll से लिंक, smooth rotation
            // markers: true,
          },
        });
      }
    }, sectionRef); // Passing sectionRef limits the scope of all GSAP operations

    // Cleanup function for GSAP context
    return () => context.revert();
  }, []);

  return (
    // sectionRef added here
    <section
      className="bg-[#1C233A] text-white overflow-hidden relative mt-20 font-[Sora]"
      ref={sectionRef}
    >
      <div className="absolute top-0 left-0 w-full h-full  overflow-hidden pointer-events-none">
        <img
          src="/images/aboutImg/bgfounder.png"
          alt="Sanket Patel, Founder & CEO"
          className=" absolute top-0 left-0  object-cover"
        />
      </div>
      {/* Optional: Background pattern/graphic. This is a simplified circle/radial gradient. */}

      <div className="max-w-[1620px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col lg:flex-row items-center lg:items-end justify-between gap-12  ">
          {/* --- Right Side: Text Content - .right-content-container added here --- */}
          <div className="w-full lg:pl-16 text-center lg:text-left py-16 md:py-24 right-content-container">
            {/* Divider Line placeholder for animation 2 */}

            {/* All main text elements get .animated-text-content */}
            <h2 className="text-[30px] md:text-[40px] 2xl:text-[60px] font-bold mb-6 leading-tight animated-text-content">
              A more from our Founder
            </h2>

            <p className="text-gray-300 text-[20px] md:text-[24px]  mb-6 animated-text-content text-justify">
              "Building one of Asia’s largest biogas plants was not just a
              dream—it was a responsibility. At Govardhannathji Energies LLP, I
              lead with purpose, passion, and the belief that every action we
              take can drive sustainable growth and meaningful change for our
              planet."
            </p>

            {/* The text is duplicated in the original image, so we'll include the duplication */}
            {/* <p className="text-gray-300 text-[20px] md:text-[24px] mb-10 animated-text-content">
              Our farm's productivity increased significantly with their organic
              fertilizers, and the bio gas solutions helped cut energy costs.
              Truly sustainable, eco-friendly, and effective—highly recommended
              for anyone seeking greener solutions!
            </p> */}

            {/* Signature and Title */}
            <div className=" mt-[50px]">
              <div>
                <div className="relative w-[fit-content] ">
                  {/* <img
              alt="Sanket Patel, Founder & CEO"
              className="w-full h-auto rounded-md shadow-lg"
              style={{
                clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
              }}
            /> */}
                  <a
                    href="https://youtu.be/aHCiI1qs-o8"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Watch Video"
                    className=" bottom-[150px] left-[80px] md:left-[0px] flex items-center gap-4 bg-white/20 backdrop-blur-md border border-white/30 text-white pl-2 pr-8 py-2 rounded-full font-medium hover:bg-white/30 transition duration-300 shadow-2xl group"
                  >
                    {/* The White Play Button Circle */}
                    {/* <div className="bg-white rounded-full w-12 h-12 flex items-center justify-center shadow-lg transition-transform group-hover:scale-105"> */}
                    <svg
                      className="w-10 h-10 mr-2"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                    {/* </div> */}
                    <span className="text-[24px] font-normal">Watch Video</span>
                  </a>
                </div>
              </div>
              <div className="mt-8 text-right">
                {/* This is a placeholder for the signature image/font */}
                <div className="flex items-end justify-end">
                  <img
                    src="/images/aboutImg/signature.webp"
                    alt="Sanket Patel Signature"
                  />
                </div>
                <p className="text-[24px] font-semibold text-gray-400">
                  Founder, CEO
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* --- Left Side: Image and Watch Video Button --- */}
      <div className="w-full flex justify-center lg:justify-start relative mb-8 lg:mb-0 ">
        {/* Image Container with subtle border/shadow effect */}
        <div className="relative w-full max-w-sm md:max-w-md lg:max-w-full">
          {/* Rotaing Image Container - ref={droppedImageRef} added here */}
          <div className="absolute hidden lg:block left-[-400px] top-[0px]">
            <img
              src="/images/img_dropped_image.webp"
              alt="Sustainable Solutions"
              // rounded-full class added to make the image round
              className="main-image-container max-w-[fit-content] h-full object-contain rounded-full relative "
              ref={droppedImageRef}
            />
          </div>

          {/* Watch Video Button - Positioned absolutely near the bottom center */}
        </div>
      </div>
    </section>
  );
};

export default FounderTestimonial;
